/**
 * TSIResults Component
 * Displays Tom Short Index results showing total times for each rider
 */

import 'react';

function TSIResults({ results, year }) {
  if (!results || !results.results || results.results.length === 0) {
    return (
      <div className="tsi-results">
        <div className="no-results">
          <h3>No Common Events Found</h3>
          <p>These riders did not compete together at any hills in {year}.</p>
        </div>
      </div>
    );
  }

  const formatTime = (seconds) => {
    return seconds.toFixed(2) + 's';
  };

  const formatGap = (seconds) => {
    if (seconds === 0) return '-';
    return (seconds > 0 ? '+' : '') + seconds.toFixed(2) + 's';
  };

  const getPositionEmoji = (position) => {
    switch (position) {
      case 1: return '🥇';
      case 2: return '🥈';
      case 3: return '🥉';
      default: return '';
    }
  };

  // Calculate gaps from leader
  const leaderTime = results.results[0]?.total_time || 0;
  const resultsWithGaps = results.results.map(result => ({
    ...result,
    gap: result.total_time - leaderTime,
    gap_per_event: result.event_count > 0 ? (result.total_time - leaderTime) / result.event_count : 0
  }));

  return (
    <div className="tsi-results">
      <div className="tsi-header">
        <h2>🏆 Tom Short Index</h2>
        <p className="tsi-subtitle">
          {year} • {results.common_events.length} event{results.common_events.length !== 1 ? 's' : ''} 
          {' '}where all riders competed
        </p>
      </div>

      <div className="tsi-standings">
        {resultsWithGaps.map((result, index) => (
          <div key={index} className={`tsi-card position-${result.position}`}>
            <div className="tsi-position">
              <span className="position-emoji">{getPositionEmoji(result.position)}</span>
              <span className="position-number">#{result.position}</span>
            </div>
            
            <div className="tsi-rider-info">
              <h3 className="rider-name">{result.rider.fullname}</h3>
              <p className="event-count">
                {result.event_count} event{result.event_count !== 1 ? 's' : ''}
              </p>
            </div>

            <div className="tsi-times">
              <div className="time-item">
                <span className="time-label">Total</span>
                <span className="time-value total">{formatTime(result.total_time)}</span>
              </div>
              {result.position > 1 && (
                <>
                  <div className="time-separator">|</div>
                  <div className="time-item">
                    <span className="time-label">Gap</span>
                    <span className="time-value gap">{formatGap(result.gap)}</span>
                  </div>
                  <div className="time-separator">|</div>
                  <div className="time-item">
                    <span className="time-label">Gap/Event</span>
                    <span className="time-value gap-avg">{formatGap(result.gap_per_event)}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="tsi-events-summary">
        <h4>Common Events</h4>
        <div className="events-list">
          {results.common_events.map((event, idx) => (
            <span key={idx} className="event-badge">
              {event.hill}
            </span>
          ))}
        </div>
      </div>

      <div className="tsi-info">
        <p>
          <strong>How TSI Works:</strong> The Tom Short Index compares riders by adding up 
          their fastest times (Timed or Top Ten runs) across all hills where they competed 
          together. Lowest total time wins! 🏁
        </p>
      </div>
    </div>
  );
}

export default TSIResults;
